import React, { FC } from "react"
import awicon from "../../../assets/images/services-icon/coin.png"
import moment from "moment-timezone"
import { Button, Progress } from "reactstrap"
import { ActivityUtil } from "./activity-util"
import { SessionLessonData } from "./session"
import hw1 from "../../../assets/images/services-icon/hw1.svg"
import { ActivityType } from "./activity.types"
import { LessonActivityOnetime } from "./lesson-activity.types"


const formatTime = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  const formattedTime = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`
  return formattedTime
}

const ActivityMetaData: Record<number, { typeName: string, isPlatform: boolean, fixedCoins: number }> = {
  [ActivityType.MY_LIBRARY_TASK]: {
    typeName: "Task", isPlatform: false, fixedCoins: 0
  },
  [ActivityType.MY_LIBRARY_LINK]: {
    typeName: "Link", isPlatform: false, fixedCoins: 0
  },
  [ActivityType.TUTOR_LIBRARY_ITEM]: {
    typeName: "File", isPlatform: false, fixedCoins: 0
  },
  [ActivityType.MY_LIBRARY_VIDEO]: {
    typeName: "Video", isPlatform: false, fixedCoins: 0
  },
  [ActivityType.MY_LIBRARY_WORKSHEET]: {
    typeName: "Worksheet", isPlatform: false, fixedCoins: 0
  },
  [ActivityType.PLATFORM_VIDEO]: {
    typeName: "Video", isPlatform: true, fixedCoins: 0
  },
  [ActivityType.PLATFORM_WORKSHEET]: {
    typeName: "Worksheet", isPlatform: true, fixedCoins: 20
  },
  [ActivityType.ONETIME]: {
    typeName: "Task", isPlatform: false, fixedCoins: 0
  }
}


type HandledTypes = LessonActivityOnetime

interface GeneralActivityCardProps {
  activity: HandledTypes,
  sessionLessonData: SessionLessonData
  index: number
  onClick?: () => void
}

export const GeneralActivityCard: FC<GeneralActivityCardProps> = (props: GeneralActivityCardProps) => {

  const { activity, index, sessionLessonData, onClick } = props
  const activityMetaData = ActivityMetaData[activity.activity_type]

  let total_coins = 0
  let total_time = 0
  let total_question = 0
  let count_answer = 0
  let percentage = 0

  activity.LessonActivitiesQuestions?.forEach((activityQuestion, index2) => {
    activityQuestion?.question?.forEach((question) => {
      total_question += 1
      total_coins += 2
      if (question.StudentAnsAttempts && question.StudentAnsAttempts.length > 0) {
        question.StudentAnsAttempts.forEach((stuAnswer) => {
          total_time += stuAnswer.submitted_on
        })
        count_answer += 1
      }
    })
  })

  if (total_question >= count_answer && total_question != 0) {
    percentage = (count_answer / total_question) * 100
  }

  return (

    <li className="d-flex justify-content-between" key={index}>
      <div className="d-flex align-items-start">
        {activity && activity.status && activity.status === 1 ?
          <div className="hw-icon bg-success text-white font-size-24 me-3">
            <i className="fas fa-check-circle"></i>
          </div>
          :
          <div className="hw-icon">
            <img width={24} className="" src={hw1} alt="" />
          </div>
        }

        <div>
          <p className="text-warning mb-2 fw-bold font-size-12 text-uppercase">
            {activityMetaData.typeName}
          </p>
          <h4 className=" fw-bold font-size-24">
            {ActivityUtil.activityName(activity)}
          </h4>
          <div className="ft-util d-flex">
            <div className="d-flex align-items-center font-size-18 fw-medium">
            </div>
            <div className="d-flex align-items-center font-size-18 fw-medium me-3">
              {" "}
              <img width={24} className="me-2" src={awicon} alt="" />
              {activity.coins_earned ? activity.coins_earned : 0}
              /{activity.activity_node?.[0]?.coins !== undefined && activity.activity_node?.[0]?.coins !== null
              ? activity.activity_node[0]?.coins
              : 2}{" "} Coins
            </div>
          </div>
        </div>
      </div>

      {activity && activity.status && activity.status === 1 ?

        <div className="hw-status text-end">
          <div className="direct_link">
            <div className="d-flex align-items-center text-success fw-bold text-uppercase" onClick={onClick}>
              <span className="mcr-success"></span>Completed
            </div>
          </div>
          <p className="mb-0 text-uppercase font-size-12">{formatTime(total_time)} Mins</p>
        </div>

        :

        ((sessionLessonData?.session?.ses_is_completed === 1 && sessionLessonData?.session?.tbl_session_time?.tbl_student_enrolment?.[0]?.tbl_session_attendance?.is_flexi != 1)
          ||
          (sessionLessonData?.session?.ses_status === 1
            && sessionLessonData?.session?.tbl_session_time?.tbl_student_enrolment?.[0]?.tbl_session_attendance?.is_flexi == 1 &&
            (moment(sessionLessonData.session.ses_date).tz(localStorage.getItem("cent_timezone_identifier")
                || "Europe/London").add((sessionLessonData?.session?.tut_flexi_days + 1 || 0), "days")
              <
              moment().tz(localStorage.getItem("cent_timezone_identifier") || "Europe/London")
            )
          )) ?
          <div className="direct_link">
            <div className="hw-status text-end">
              {percentage !== 0 ?
                <div className="d-flex align-items-center text-danger fw-bold text-uppercase">
                  Incomplete
                </div>
                :
                <div className="d-flex align-items-center text-danger fw-bold text-uppercase">
                  Missed
                </div>}
            </div>
          </div>
          :
          sessionLessonData && sessionLessonData.session && sessionLessonData.session.ses_status !== 1 ?
            <div className="direct_link">
              <div className="hw-status text-end">

                <div className="d-flex align-items-center text-dark fw-bold text-uppercase">
                  SESSION HAS NOT BEEN STARTED
                </div>

              </div>
            </div>

            :
            <div className="direct_link">
              <div className="hw-status text-end">
                {percentage !== 0 ?

                  <Button className="btn btn-danger cs-btn-danger text-uppercase" onClick={onClick}>
                    Resume
                  </Button>
                  :
                  <Button className="btn btn-danger cs-btn-danger text-uppercase" onClick={onClick}>
                    Start
                  </Button>
                }
              </div>
            </div>
      }
      <div className="ph_list-progressbar">
        <Progress color="success" value={percentage !== 0 ? percentage : 0} />
      </div>
    </li>


  )
}